module.exports = __webpack_public_path__ + "img/speed.67eb0855.png";